import { useFormik } from 'formik';
import * as Yup from 'yup';

const PracticeAddressSchema = Yup.object().shape({
  address1: Yup.string().required('Address is required'),
  city: Yup.string().required('City is required'),
  state: Yup.mixed()
    .required('State is required')
    .test('is-option', 'State is required', (v) => !!(v && typeof v === 'object' && 'value' in v)),
  zipCode: Yup.string().required('Zip is required')
});

export default function usePracticeAddressFormik(initialValues = {}, onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      address1: initialValues?.address1 ?? '',
      address2: initialValues?.address2 ?? '',
      city: initialValues?.city ?? '',
      state: initialValues?.state ?? '',
      zipCode: initialValues?.zipCode ?? ''
    },
    enableReinitialize: true,
    validationSchema: PracticeAddressSchema,
    onSubmit
  });

  return formik;
}
